import { db } from "../firebaseConfig";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  deleteDoc
} from "firebase/firestore";

export default {
  name: "MemberManagement",
  data() {
    return {
      users: [],
      searchTerm: "",
      visibleCount: 10, // Number of users to display initially
      isEditing: false,
      memberForm: {
        docId: "",
        uid: "Not Registered", // default for new entries
        fullName: "",
        firstName: "",
        middleName: "",
        surname: "",
        email: "",
        client: "",
        position: "",
        role: "",
        department: ""
      },
      availableProducers: [],
      showAddMemberModal: false,
      error: ""
    };
  },
  computed: {
    filteredUsers() {
      if (!this.searchTerm) return this.users;
      const term = this.searchTerm.toLowerCase();
      return this.users.filter(user =>
        (user.firstName && user.firstName.toLowerCase().includes(term)) ||
        (user.surname && user.surname.toLowerCase().includes(term))
      );
    },
    displayedUsers() {
      return this.filteredUsers.slice(0, this.visibleCount);
    }
  },
  async mounted() {
    await this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const usersArray = [];
        querySnapshot.forEach(docSnap => {
          const data = docSnap.data();
          data.docId = docSnap.id;
          if (!data.uid) {
            data.uid = "Not Registered";
          }
          usersArray.push(data);
        });
        this.users = usersArray;
      } catch (error) {
        console.error("Error fetching users:", error);
        this.error = "Error fetching users.";
      }
    },
    async fetchProducers() {
      try {
        const qSnap = await getDocs(collection(db, "users"));
        let producers = [];
        qSnap.forEach(docSnap => {
          const data = docSnap.data();
          if (data.role === "producer") {
            producers.push({
              id: docSnap.id,
              name: `${data.firstName} ${data.surname}`,
              firstName: data.firstName
            });
          }
        });
        producers.sort((a, b) => a.firstName.localeCompare(b.firstName));
        this.availableProducers = producers;
      } catch (error) {
        console.error("Error fetching producers:", error);
        this.error = "Error fetching producers.";
      }
    },
    async submitMember() {
      try {
        const memberData = {
          uid: this.memberForm.uid,
          fullName:this.memberForm.fullName,
          firstName: this.memberForm.firstName,
          middleName: this.memberForm.middleName,
          surname: this.memberForm.surname,
          email: this.memberForm.email,
          client: this.memberForm.client,
          position: this.memberForm.position,
          role: this.memberForm.role,
          department: this.memberForm.department
        };

        if (this.isEditing) {
          const docRef = doc(db, "users", this.memberForm.docId);
          await updateDoc(docRef, memberData);
          const index = this.users.findIndex(u => u.docId === this.memberForm.docId);
          if (index !== -1) {
            this.users.splice(index, 1, { ...memberData, docId: this.memberForm.docId });
          }
        } else {
          const docRef = await addDoc(collection(db, "users"), memberData);
          this.users.push({ ...memberData, docId: docRef.id });
        }
        await this.fetchUsers(); // refresh members list
        this.resetForm();
        this.showAddMemberModal = false; // close modal
      } catch (error) {
        console.error("Error submitting member:", error);
        this.error = "Error submitting member.";
      }
    },
    editMember(user) {
      this.isEditing = true;
      this.memberForm = { ...user };
      this.showAddMemberModal = true; // open modal for editing
    },
    async deleteMember(user) {
      if (!confirm("Are you sure you want to delete this member? This action cannot be undone.")) {
        return;
      }
      try {
        await deleteDoc(doc(db, "users", user.docId));
        this.users = this.users.filter(u => u.docId !== user.docId);
      } catch (error) {
        console.error("Error deleting member:", error);
        this.error = "Error deleting member.";
      }
    },
    loadMore() {
      this.visibleCount += 10;
    },
    resetForm() {
      this.isEditing = false;
      this.memberForm = {
        docId: "",
        uid: "Not Registered",
        fullName: "",
        firstName: "",
        middleName: "",
        surname: "",
        email: "",
        client: "",
        position: "",
        role: "",
        department: ""
      };
    },
    openAddMemberModal() {
      this.resetForm();
      this.showAddMemberModal = true;
    },
    closeModal() {
      this.showAddMemberModal = false;
    }
  }
};
